// utils/apiService.ts
import axios from "axios";
import { apibaseurl, leadIdFromStorage } from "../environment";

export const callService = async (
  service_name: string,
  data: { param: string; value: any }[] = []
) => {
  const lead_profile_id = localStorage.getItem("lead_profile_id") ?? "";
  // console.log(lead_profile_id, "code Lead");
  if (!lead_profile_id) {
    console.error("lead_profile_id not found in localStorage");
    return;
  }

  const payload = {
    lead_profile_id,
    service_name,
    data,
    // selectedLatLng
  };

  try {
    const response = await axios.post(
      `${apibaseurl}/api/leads/v1/create-lead`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    // console.log(
    //   `✅ Service "${service_name}" called successfully`,
    //   response.data
    // ); // ✅ success message

    return response.data;
  } catch (error) {
    console.error(`❌ Error calling "${service_name}":`, error);
    throw error;
  }
};

// // utils/apiService.ts
// import axios from "axios";
// import { apibaseurl } from "../environment";

// export const callService = async (
//   service_name: string,
//   data: { param: string; value: any }[] = []
// ) => {
//   const lead_profile_id = localStorage.getItem("lead_profile_id");

//   if (!lead_profile_id) {
//     console.error("lead_profile_id not found in localStorage");
//     return;
//   }

//   const payload = {
//     lead_profile_id,
//     service_name,
//     data,
//   };

//   try {
//     const response = await axios.post(
//       `${apibaseurl}/api/create-lead`,
//       payload,
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );
//     console.log(
//       `✅ Service "${service_name}" called successfully`,
//       response.data
//     ); // ✅ success message

//     return response.data;
//   } catch (error) {
//     console.error(`❌ Error calling "${service_name}":`, error);
//     throw error;
//   }
// };

// // utils/apiService.ts
// import axios from "axios";
// import { apibaseurl } from "../environment";

// export const callService = async (
//   service_name: string,
//   data: { param: string; value: any }[] = []
// ) => {
//   const lead_profile_id = localStorage.getItem("lead_profile_id");

//   if (!lead_profile_id) {
//     console.error("lead_profile_id not found in localStorage");
//     return;
//   }

//   const payload = {
//     lead_profile_id,
//     service_name,
//     data,
//   };

//   try {
//     // const response = await axios.post("/api/lead-service", payload, {
//     // const response = await axios.post(`/api/leads/v1/create-lead`, payload, {
//     const response = await axios.post(
//       `https://nestfin.app:8443/api/leads/v1/create-lead22`,
//       payload,
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );
//     // console.log(
//     //   `✅ Service "${service_name}" called successfully`,
//     //   response.data
//     // ); // ✅ success message

//     return response.data;
//   } catch (error: any) {
//     console.error(`❌ Error calling "${service_name}":`, error);
//     throw error;
//   }
// };

// // // useable APi Calling for get Leads

// // export const callService = async (
// //     service_name: string,
// //     data: { param: string, value: any }[] = []
// // ) => {

// //     const lead_profile_id = localStorage.getItem("lead_profile_id");

// //     if (!lead_profile_id) {
// //         console.log("Lead Profile Id not Found in LocalStorage")
// //         return;
// //     }
// //     const payload = {
// //         lead_profile_id,
// //         service_name,
// //         data
// //     };

// //     try {
// //         const response = await fetch("http://192.168.1.14:34340/api/lead-service")
// //     }

// // }
